export default __webpack_public_path__ + "static/playing_koi_2-44ad5d0340e80ffe02e4aa4f49e8a8db.svg";